<div>
  <quill-editor [formControl]="control" (ngModelChange)="updateValue($event)" [ngClass]="customClass" [placeholder]="placeholder">
  </quill-editor>
</div>
